import React from "react";

import { withRouter } from "react-router";

import { inject } from "mobx-react";

import styled, { withTheme } from "styled-components";

// import { FormattedMessage, injectIntl } from 'react-intl';

import locales from "../utils/locales";

import timestamp from "../utils/timestamp";

const Wrapper = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const Flag = styled.div`
  ${props => `background-image: url(./assets/images/flag-${props.locale}.png);`}

  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: right top;
  height: 40px;
  width: 40px;

  cursor: pointer;

  ${props =>
    props.current &&
    ` 
        background-position: left top;
    `}
`;

const mapper = (stores, props) => ({
  locale: stores.uiStore.getLocale.get(),
  setLocale: locale => stores.uiStore.setLocale(locale)
});

class LocaleSwitcher extends React.Component {
  render() {
    const { locale } = this.props;
    return (
      <Wrapper>
        <Flag
          locale="en-us"
          onClick={() => this._emitLocale("en-us")}
          current={locale === "en-us"}
        />
        <Flag
          locale="pt-br"
          onClick={() => this._emitLocale("pt-br")}
          current={locale === "pt-br"}
        />
        <Flag
          locale="fr-fr"
          onClick={() => this._emitLocale("fr-fr")}
          current={locale === "fr-fr"}
        />
        <Flag
          locale="sv-se"
          onClick={() => this._emitLocale("sv-se")}
          current={locale === "sv-se"}
        />
      </Wrapper>
    );
  }

  _emitLocale = locale => {
    // const { setLocale } = this.props;
    // setLocale && setLocale(locale);
    this.props.history.push(`/${locale}`);
  };
}

export default withRouter(withTheme(inject(mapper)(LocaleSwitcher)));



// WEBPACK FOOTER //
// ./src/components/LocaleSwitcher.js